import i18next from "i18next";
import { formatHourToString } from "./helpers";
import styled from "styled-components";
import baseTheme from "../../../../../config/baseTheme";
import { isEmpty } from "lodash";
import { fitsCapacityUsage, isSellable } from "../../../helpers/capacityUsage";

const DropdownExtra = styled.span`
  color: ${({ color }) => (color ? color : "none")};
`;

/**
 * Por qué no se puede elegir el turno, o `null` si sí se puede.
 *
 * A diferencia del dashboard, acá no se revela quién tomó el turno ni cuánta
 * gente hay: es ocupación de otro producto y el cliente no tiene por qué verla.
 * Un turno bloqueado y uno lleno se cuentan igual, "sin cupos".
 *
 * @returns {string|null} clave de traducción del motivo
 */
export const getUnavailableReasonKey = (entry, capacityUsage) => {
  // `blocked` gana sobre el cupo: a un turno tomado no se le explica además que
  // no alcanzaban los lugares.
  if (entry?.blocked || entry?.available <= 0) {
    return "experiences:availability.unavailable";
  }

  // Tiene cupo, pero no alcanza para esta venta: una privada necesita el turno
  // entero y lugares fijos necesita los N de una. Decirle "sin cupos" sería
  // falso.
  if (!fitsCapacityUsage(entry, capacityUsage)) {
    return "experiences:availability.notEnoughSeats";
  }

  return null;
};

const getExtraInfoText = (entry, capacityUsage) => {
  const reasonKey = getUnavailableReasonKey(entry, capacityUsage);

  if (reasonKey) return i18next.t(reasonKey);

  return `${entry.available} ${i18next.t("common:quotas")}`;
};

export const generatePickUpTimeOptions = (
  matchingObject,
  startTimes,
  capacityUsage
) => {
  if (isEmpty(matchingObject)) return null;
  return matchingObject?.entries
    ?.map((entry) => {
      const matchingStartTime = startTimes?.find(
        (startTime) => startTime._id === entry.startTimeId
      );

      if (!matchingStartTime) return null;

      const { hour, minute } = matchingStartTime.startTime;
      const time = formatHourToString(hour, minute);
      const sellable = isSellable(entry, capacityUsage);

      return {
        value: matchingStartTime._id,
        label: `${time} hs.`,
        disabled: !sellable,
        extraInfo: (
          <DropdownExtra
            color={sellable ? baseTheme.colors.primary : "none"}
          >
            {getExtraInfoText(entry, capacityUsage)}
          </DropdownExtra>
        ),
      };
    })
    .filter(Boolean);
};
